// extracted by mini-css-extract-plugin
export default {"area":"style_area__DMO2X","circles":"style_circles__Ifroe","animate":"style_animate__FZZB3"};